import { createRequestTypes } from 'common/websocket-redux';

export const GET_FEATURE_FLAGS = createRequestTypes('flags/GET_FEATURE_FLAGS');
